import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Form, Col, Row, Button, Table,
} from 'react-bootstrap';
import Moment from 'react-moment';
import { getUserLoginHistory, getConsoleUserByNameOrNumber } from '../../actions/userLogActions';

import Pagination from '../subLevel/Pagination';
import LogDetails from '../Others/LogDetailsWORedux';

class ConsoleLogs extends Component {
  constructor() {
    super();
    this.state = {
      searchValue: '',
      pageNo: 1,
      pageSize: 10,
      totalPages: null,
      logData: [],
      userData: {},
      viewDetails: false,
      viewDetailsDate: null,
      error: '',
    };
  }

  onChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
    const key = e.target.value;
    const { page } = this.state;
    if (e.target.value.length >= 1) {
      this.props.getConsoleUserByNameOrNumber({ key, page });
    }
  };

  onSubmit = (e) => {
    e.preventDefault();
  }

  getLogs(data) {
    this.setState({
      userData: data,
    });
    const searchData = {
      pageNo: this.state.pageNo,
      pageSize: this.state.pageSize,
      user_id: data._id,
    };

    this.props.getUserLoginHistory(searchData)
      .then((resp) => {
        this.setState({
          logData: resp.result,
          pageNo: resp.pageNo,
          pageSize: resp.pageSize,
          totalPages: resp.totalPages,
        });
      })
      .catch((err) => {
        this.setState({ error: err });
      });
  }

  viewLogDetails = (id) => {
    this.setState({
      viewDetails: true,
      viewDetailsDate: id,
    });
  }

  backToListHandler = () => {
    this.setState({
      viewDetails: false,
      viewDetailsDate: null,
    });
  }

  switchPage = (searchData) => {
    searchData.user_id = this.state.userData._id;
    this.props.getUserLoginHistory(searchData)
      .then((resp) => {
        this.setState({
          logData: resp.result,
          pageNo: resp.pageNo,
          pageSize: resp.pageSize,
          totalPages: resp.totalPages,
        });
      })
      .catch((err) => {
        this.setState({ error: err });
      });
  }

  render() {
    let consoleLogsList;
    let suggestions;
    if (this.state.logData.length > 0) {
      consoleLogsList = this.state.logData.map((log) => (
        <tr key={log._id}>
          <td><Moment format="DD-MM-YYYY">{log._id}</Moment></td>
          <td>{log.actions.length}</td>
          <td>
            <button onClick={() => this.viewLogDetails(log._id)}> View details</button>
          </td>
        </tr>
      ));
    } else {
      consoleLogsList = <p> No data found</p>;
    }

    if (this.props.consoleUserSuggestions) {
      suggestions = this.props.consoleUserSuggestions.map((item) => (
        <li style={{ cursor: 'pointer', color: 'blue' }} onClick={() => this.getLogs(item)}>
          {item.name}
          {' '}
          /
          {' '}
          {item.email}
          {' '}
          /
          {' '}
          {item.phone_number}
        </li>
      ));
    }

    const filterOptions = (
      <>
        <Col>

          <label>Name / Email / Phone Number</label>
          <input
            type="text"
            id="searchValue"
            onChange={this.onChange}
            value={this.state.searchValue}
          />
        </Col>
        <ul>
          {suggestions}
        </ul>
      </>
    );

    if (this.state.viewDetails) {
      return <LogDetails Userlogs={this.state.logData} date={this.state.viewDetailsDate} goBackToListHandler={this.backToListHandler} />;
    }

    return (
      <div>
        <h1>Console logs</h1>
        <Form onSubmit={this.onSubmit} className="bg-red">
          <Row>
            <Col>
              {filterOptions}
            </Col>
          </Row>
        </Form>
        <hr />

        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Date</th>
              <th>Sessions count</th>
              <th>details</th>
            </tr>
          </thead>
          <tbody>
            {consoleLogsList}

          </tbody>
        </Table>
        {(this.state.logData.length > 0)
          ? (
            <Pagination
              currentPage={this.state.pageNo}
              lastPage={this.state.totalPages}
              getInfo={this.switchPage}
            />
          )
          : null}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  consoleUserlogs: state.logs.consoleUsers,
  consoleUserSuggestions: state.logs.consoleUserSuggestions,

});
export default connect(mapStateToProps, { getUserLoginHistory, getConsoleUserByNameOrNumber })(ConsoleLogs);
